import { createHttpClient } from "./http";

export class FornecedorRepository {
	constructor() {
		this.axios = createHttpClient({ timeout: 300000 });
	}

	async buscarPorCnpj(cnpj) {
		try {
			const result = await this.axios.get(`fornecedor-unidade-distribuidora/buscar-por-cnpj/${cnpj}`, {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`,
				},
			});

			return result.data;
		} catch (error) {
			if (error.response?.status === 401)
				throw new Error("Usuário não autenticado.");

			throw new Error(error.response?.data?.message || "Erro ao buscar propriedade por CNPJ.");
		}
	}

	async buscarPorNumeroSequencial(numeroSequencial) {
		try {
			const result = await this.axios.get(`fornecedor-unidade-distribuidora/buscar-por-numero-sequencial/${numeroSequencial}`, {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`,
				},
			});

			return result.data;
		} catch (error) {
			if (error.response?.status === 401)
				throw new Error("Usuário não autenticado.");

			throw new Error(error.response?.data?.message || "Erro ao buscar propriedade por número sequencial.");
		}
	}

	async buscarPorPropriedadeId(id) {
		try {
			const result = await this.axios.get(`fornecedor-unidade-distribuidora/buscar-por-propriedade/${id}`, {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`,
				},
			});

			return result.data;
		} catch (error) {
			if (error.response?.status === 401)
				throw new Error("Usuário não autenticado.");

			throw new Error(error.response?.data?.message || "Erro ao buscar propriedade.");
		}
	}

	async save(formData) {
		try {
			const result = await this.axios.post("fornecedor-unidade-distribuidora", formData, {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`,
					"Content-Type": "multipart/form-data",
				},
			});

			return result.data;
		} catch (error) {
			if (error.response?.status === 401)
				throw new Error("Usuário não autenticado.");

			throw new Error(error.response?.data?.message || "Erro ao salvar fornecedor.");
		}
	}

	async update(formData) {
		try {
			const result = await this.axios.put("fornecedor-unidade-distribuidora", formData, {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`,
					"Content-Type": "multipart/form-data",
				},
			});

			return result.data;
		} catch (error) {
			if (error.response?.status === 401)
				throw new Error("Usuário não autenticado.");

			throw new Error(error.response?.data?.message || "Erro ao atualizar fornecedor.");
		}
	}

	async previaImportacao(unidadeDistribuidoraId, linhas) {
		try {
			const result = await this.axios.post(
				"fornecedor-unidade-distribuidora/importar/previa",
				{ unidadeDistribuidoraId, linhas },
				{ headers: { Authorization: `Bearer ${localStorage.getItem("access_token")}` } }
			);
			return result.data;
		} catch (error) {
			if (error.response?.status === 401)
				throw new Error("Usuário não autenticado.");
			throw new Error(error.response?.data?.message || "Erro ao analisar a planilha.");
		}
	}

	async importar(unidadeDistribuidoraId, linhas) {
		try {
			const result = await this.axios.post(
				"fornecedor-unidade-distribuidora/importar",
				{ unidadeDistribuidoraId, linhas },
				{ headers: { Authorization: `Bearer ${localStorage.getItem("access_token")}` } }
			);
			return result.data;
		} catch (error) {
			if (error.response?.status === 401)
				throw new Error("Usuário não autenticado.");
			throw new Error(error.response?.data?.message || "Erro ao importar fornecedores.");
		}
	}

	async getAll(unidadeDistribuidoraId, page = 1, limit = 10, search = "") {
		try {
			const params = { unidadeDistribuidoraId, page, limit };
			if (search) {
				params.search = search;
			}

			const result = await this.axios.get("fornecedor-unidade-distribuidora", {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`
				},
				params
			});

			return result.data;
		} catch (error) {
			if(error.response?.status === 401)
				throw new Error("Usuário não autenticado.");

			throw new Error(error.response?.data?.message || "Erro ao carregar fornecedores.");
		}
	}

	async getById(id) {
		try {
			const result = await this.axios.get(`fornecedor-unidade-distribuidora/${id}`, {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`
				}
			});

			return result.data;
		} catch (error) {
			if(error.response?.status === 401)
				throw new Error("Usuário não autenticado.");
			if(error.response?.status === 404)
				throw new Error("Fornecedor não encontrado.");

			throw new Error(error.response?.data?.message || "Erro ao carregar fornecedor.");
		}
	}

	async changeVisibility(id) {
		try {
			const result = await this.axios.put(`fornecedor-unidade-distribuidora/${id}/change-visibility`, null, {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`,
				},
			});

			return result.data;
		} catch (error) {
			if (error.response?.status === 401)
				throw new Error("Usuário não autenticado.");

			throw new Error(error.response?.data?.message || "Erro ao alterar visibilidade do fornecedor.");
		}
	}

	async getSolicitacoes(unidadeDistribuidoraId, status = "PENDENTE") {
		try {
			const result = await this.axios.get("fornecedor-unidade-distribuidora/solicitacoes", {
				headers: { Authorization: `Bearer ${localStorage.getItem("access_token")}` },
				params: { unidadeDistribuidoraId, status },
			});
			return result.data;
		} catch (error) {
			if (error.response?.status === 401)
				throw new Error("Usuário não autenticado.");
			throw new Error(error.response?.data?.message || "Erro ao carregar solicitações.");
		}
	}

	async aceitarSolicitacao(id) {
		try {
			const result = await this.axios.put(`fornecedor-unidade-distribuidora/solicitacoes/${id}/aceitar`, null, {
				headers: { Authorization: `Bearer ${localStorage.getItem("access_token")}` },
			});
			return result.data;
		} catch (error) {
			if (error.response?.status === 401)
				throw new Error("Usuário não autenticado.");
			throw new Error(error.response?.data?.message || "Erro ao aceitar solicitação.");
		}
	}

	async recusarSolicitacao(id) {
		try {
			const result = await this.axios.put(`fornecedor-unidade-distribuidora/solicitacoes/${id}/recusar`, null, {
				headers: { Authorization: `Bearer ${localStorage.getItem("access_token")}` },
			});
			return result.data;
		} catch (error) {
			if (error.response?.status === 401)
				throw new Error("Usuário não autenticado.");
			throw new Error(error.response?.data?.message || "Erro ao recusar solicitação.");
		}
	}
}
